document.addEventListener("DOMContentLoaded", function () {
  const drawer = document.getElementById("cl-popup--drawer");
  const overlay = document.getElementById("cl-popup--drawer-overlay");
  const openBtns = document.querySelectorAll(".cl-popup--open-btn, .cl-nav-drawer-region--open-btn");
  const closeBtn = document.querySelector(".cl-popup--close");
  const form = document.getElementById("cl-localization--form");
  const continentSelect = document.getElementById("cl-continent");
  const countrySelect = document.getElementById("cl-country");
  const languageSelect = document.getElementById("cl-language");
  let localizationData = {};
  fetch(window.localizationJsonUrl)
      .then(res => {
          if (!res.ok) throw new Error("Failed to load localization JSON");
          return res.json();
      })
      .then(data => {
          localizationData = data;

          // === Default Selections ===
          const defaultContinent = "Middle East";
          const defaultCountry = "United Arab Emirates";
          const isArabic = window.location.pathname.includes("/ar");
          const defaultLanguage = isArabic ? "Arabic" : "English";

          // Set continent
          continentSelect.value = defaultContinent;

          const countries = localizationData[defaultContinent] || {};
          countrySelect.innerHTML = '';
          for (const country in countries) {
              const opt = document.createElement("option");
              opt.value = country;
              opt.textContent = country;
              countrySelect.appendChild(opt);
          }
          countrySelect.value = defaultCountry;

          const countryData = countries[defaultCountry];
          languageSelect.innerHTML = '';
          countryData.languages.forEach(lang => {
              const opt = document.createElement("option");
              opt.value = lang;
              opt.textContent = lang;
              languageSelect.appendChild(opt);
          });
          languageSelect.value = defaultLanguage;
      })
      .catch(error => {
          console.error("Localization JSON fetch error:", error);
      });

  continentSelect.addEventListener("change", function () {
      const continent = this.value;
      const countries = localizationData[continent] || {};

      countrySelect.innerHTML = '';
      languageSelect.innerHTML = '';

      const countryList = Object.keys(countries);
      if (countryList.length > 0) {
          countryList.forEach(country => {
              const opt = document.createElement("option");
              opt.value = country;
              opt.textContent = country;
              countrySelect.appendChild(opt);
          });

          // Auto-select first country
          const firstCountry = countryList[0];
          countrySelect.value = firstCountry;

          // Populate and auto-select first language
          const countryData = countries[firstCountry];
          const langs = countryData?.languages || [];

          languageSelect.innerHTML = '';
          langs.forEach(lang => {
              const opt = document.createElement("option");
              opt.value = lang;
              opt.textContent = lang;
              languageSelect.appendChild(opt);
          });

          if (langs.length > 0) {
              languageSelect.value = langs[0];
          }
      }
  });
  countrySelect.addEventListener("change", function () {
      const continent = continentSelect.value;
      const country = this.value;
      const countryData = localizationData[continent]?.[country];

      languageSelect.innerHTML = '';

      const langs = countryData?.languages || [];
      langs.forEach(lang => {
          const opt = document.createElement("option");
          opt.value = lang;
          opt.textContent = lang;
          languageSelect.appendChild(opt);
      });

      if (langs.length > 0) {
          languageSelect.value = langs[0];
      }
  });
  form.addEventListener("submit", function (e) {
      e.preventDefault();
      const continent = continentSelect.value;
      const country = countrySelect.value;
      const language = languageSelect.value;

      const url = localizationData[continent]?.[country]?.urls?.[language];
      if (url) {
          window.location.href = url;
      } else {
          alert("Please complete all selections.");
      }
  });
  // Track if we've locked the scroll
  let scrollLocked = false;

  function openDrawer() {
      drawer.classList.add("active");
      overlay.classList.add("active");

      // Only lock scroll if it's not already locked
      if (!scrollLocked) {
          document.body.classList.add('body-lock-scroll');
          scrollLocked = true;
      }
  }
  function closeDrawer() {
      drawer.classList.remove("active");
      overlay.classList.remove("active");
      document.body.classList.remove('body-lock-scroll');

      // Only unlock scroll if we locked it
      if (scrollLocked) {
          document.body.classList.remove('body-lock-scroll');
          scrollLocked = false;
      }

      // Additional check for other drawers (kept your original logic)
      if (!document.querySelector('.cl-nav-drawer--drawer')?.classList.contains('active')) {
          document.body.style.overflow = "";
          scrollLocked = false;
      }
  }
  openBtns.forEach(btn => btn.addEventListener("click", openDrawer));
  closeBtn?.addEventListener("click", closeDrawer);
  overlay?.addEventListener("click", closeDrawer);
});